import React, { createContext, useState, useCallback } from 'react';
import BadgeUnlockModal from '../components/modals/BadgeUnlockModal';

export const BadgeContext = createContext(null);

export const BadgeProvider = ({ children }) => {
  const [badge, setBadge] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  // The function to call from anywhere in the app to show a badge
  const showBadge = useCallback((badgeDetails) => {
    setBadge(badgeDetails);
    setIsOpen(true);
  }, []);

  const hideBadge = useCallback(() => {
    setIsOpen(false);
    // We delay clearing the badge data to allow for the exit animation
    setTimeout(() => {
      setBadge(null);
    }, 300); 
  }, []);

  return (
    <BadgeContext.Provider value={{ showBadge }}>
      {children}
      <BadgeUnlockModal badge={badge} isOpen={isOpen} onClose={hideBadge} />
    </BadgeContext.Provider>
  );
};
